import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Collapse } from "reactstrap";
import Logo from "../../../components/Logo/Logo";
import "./Sidebar.scss";

export default function Layout({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const navOnClick = () => {
    const sidebarToggle = document.body.querySelector("#sidebarToggle");
    if (sidebarToggle) {
      document.body.classList.toggle("sb-sidenav-toggled");
      localStorage.setItem(
        "sb|sidebar-toggle",
        document.body.classList.contains("sb-sidenav-toggled")
      );
    }
  };

  return (
    <>
      <div className={`flex d-flex`} id="wrapper">
        <div className={`sidebar border-end bg-white`} id="sidebar-wrapper">
          <div className="list-group list-group-flush">
            <div className="main_nav">
              <div className="nav">
                <div className="box">
                  <Logo />
                  <ul className="navbar-nav mr-auto">
                    <li className="nav_item">
                      <Link to="/">Home</Link>
                    </li>
                    <ul className="nav_item">
                      <p onClick={toggle}>Categorías</p>
                      <Collapse
                        isOpen={isOpen}
                        className={`${isOpen ? "open" : ""}`}
                      >
                        <li className="nav_item">
                          <Link
                            to={{ pathname: "/proyecto/productos-y-comida/" }}
                          >
                            Producto y comida
                          </Link>
                        </li>
                        <li className="nav_item">
                          <Link to={{ pathname: "/proyecto/moda/" }}>Moda</Link>
                        </li>
                        <li className="nav_item">
                          <Link to={{ pathname: "/proyecto/retratos/" }}>
                            Retratos
                          </Link>
                        </li>
                        <li className="nav_item">
                          <Link to={{ pathname: "/proyecto/publicaciones_/" }}>
                            Publicaciones
                          </Link>
                        </li>
                        <li className="nav_item">
                          <Link to={{ pathname: "/proyecto/reel/" }}>Reel</Link>
                        </li>
                      </Collapse>
                    </ul>
                    <li className="nav_item">
                      <Link to="/sobre-mi">Sobre Mi</Link>
                    </li>
                    <li className="nav_item">
                      <Link to="/contacto">Contacto</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content-wrapper">
          <nav className="navbar navbar-expand-lg navbar-light bg-light border-bottom d-block d-md-none">
            <div className="container-fluid">
              <button className="btn" id="sidebarToggle" onClick={navOnClick}>
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          </nav>
          <div>{children}</div>
        </div>
      </div>
    </>
  );
}
